export function getYYFromReleaseDate(date?: string) : string {
  return (date) ? date.match(/^\d\d(\d\d)/)?.[1] ?? '' : '';
}

export function getYYYYFromReleaseDate(date?: string) : string {
  return (date) ? date.substr(0, 4) : '';
}
